import { Button, notification, Spin } from 'antd';
import React, { useState, useCallback } from 'react';
import * as dashboardService from '../../../../services/Dashboard';

function PreviewProfileButton () {
  const [loading, setLoading] = useState(false);
  const getTuringResumeLink = useCallback(() => {
    setLoading(true);
    dashboardService
      .getTuringResumeLink()
      .then(result => {
        if (result && result.data && result.data.link) {
          window.open(result.data.link);
        } else {
          notification.error({ message: 'Error occurred when loading the resume link.' });
        }
        setLoading(false);
      })
      .catch(error => {
        notification.error({ message: 'Error occurred when loading the resume link.' });
        console.error(error);
        setLoading(false);
      });
  }, []);
  return (
    <Spin spinning={loading}>
      <Button type="primary" ghost onClick={getTuringResumeLink} className="preview-resume-btn">
        <span className="material-icons" style={{ color: '#2E6EDF', fontSize: '16.67px', marginRight: 10 }}>account_circle</span>
        Preview My Profile
      </Button>
    </Spin>
  );
}

export default React.memo(PreviewProfileButton);
